import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import AiAccess from "@/pages/AiAccess";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/ai-access")({
  head: () => ({
    meta: [
      { title: "AI Access — Connect LLMs & Agents to Statlign (MCP)" },
      { name: "keywords", content: seoFor({ topics: ["home"] }).meta },
      { name: "description", content: "How AI agents and LLMs discover and call Statlign's Model Context Protocol (MCP) endpoints: public and keyed URLs, required headers, rate limits and connection snippets." },
      { property: "og:title", content: "AI Access — Connect LLMs & Agents to Statlign (MCP)" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "How AI agents and LLMs discover and call Statlign's Model Context Protocol (MCP) endpoints: public and keyed URLs, required headers, rate limits and connection snippets." },
      { name: "twitter:title", content: "AI Access — Connect LLMs & Agents to Statlign (MCP)" },
      { name: "twitter:description", content: "How AI agents and LLMs discover and call Statlign's Model Context Protocol (MCP) endpoints: public and keyed URLs, required headers, rate limits and connection snippets." },
    ],
  }),
  component: () => (
    <MainLayout>
      <AiAccess />
    </MainLayout>
  ),
});
